"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePermissions = void 0;
var TablePermissions;
(function (TablePermissions) {
    TablePermissions["USER_INSERT"] = "user_insert";
    TablePermissions["USER_SELECT"] = "user_select";
    TablePermissions["USER_UPDATE"] = "user_update";
    TablePermissions["USER_DELETE"] = "user_delete";
    TablePermissions["USER_GROUP_INSERT"] = "user_group_insert";
    TablePermissions["USER_GROUP_SELECT"] = "user_group_select";
    TablePermissions["USER_GROUP_UPDATE"] = "user_group_update";
    TablePermissions["USER_GROUP_DELETE"] = "user_group_delete";
    TablePermissions["PERMISSION_INSERT"] = "permission_insert";
    TablePermissions["PERMISSION_SELECT"] = "permission_select";
    TablePermissions["PERMISSION_UPDATE"] = "permission_update";
    TablePermissions["PERMISSION_DELETE"] = "permission_delete";
    TablePermissions["ASSET_INSERT"] = "asset_insert";
    TablePermissions["ASSET_SELECT"] = "asset_select";
    TablePermissions["ASSET_UPDATE"] = "asset_update";
    TablePermissions["ASSET_DELETE"] = "asset_delete";
    TablePermissions["ASSET_GROUP_INSERT"] = "asset_group_insert";
    TablePermissions["ASSET_GROUP_SELECT"] = "asset_group_select";
    TablePermissions["ASSET_GROUP_UPDATE"] = "asset_group_update";
    TablePermissions["ASSET_GROUP_DELETE"] = "asset_group_delete";
    TablePermissions["ASSET_CLASS_INSERT"] = "asset_class_insert";
    TablePermissions["ASSET_CLASS_SELECT"] = "asset_class_select";
    TablePermissions["ASSET_CLASS_UPDATE"] = "asset_class_update";
    TablePermissions["ASSET_CLASS_DELETE"] = "asset_class_delete";
    TablePermissions["ASSET_OPERATING_HOUR_INSERT"] = "asset_operating_hour_insert";
    TablePermissions["ASSET_OPERATING_HOUR_SELECT"] = "asset_operating_hour_select";
    TablePermissions["ASSET_OPERATING_HOUR_UPDATE"] = "asset_operating_hour_update";
    TablePermissions["ASSET_OPERATING_HOUR_DELETE"] = "asset_operating_hour_delete";
    TablePermissions["ASSET_GROUP_OPERATING_HOUR_INSERT"] = "asset_group_operating_hour_insert";
    TablePermissions["ASSET_GROUP_OPERATING_HOUR_SELECT"] = "asset_group_operating_hour_select";
    TablePermissions["ASSET_GROUP_OPERATING_HOUR_UPDATE"] = "asset_group_operating_hour_update";
    TablePermissions["ASSET_GROUP_OPERATING_HOUR_DELETE"] = "asset_group_operating_hour_delete";
    TablePermissions["ASSET_BOOKING_INSERT"] = "asset_booking_insert";
    TablePermissions["ASSET_BOOKING_SELECT"] = "asset_booking_select";
    TablePermissions["ASSET_BOOKING_SELECT_APPROVER"] = "asset_booking_select_approver";
    TablePermissions["ASSET_BOOKING_UPDATE"] = "asset_booking_update";
    TablePermissions["ASSET_BOOKING_UPDATE_APPROVER"] = "asset_booking_update_approver";
    TablePermissions["ASSET_BOOKING_DELETE"] = "asset_booking_delete";
    TablePermissions["MEDIA_INSERT"] = "media_insert";
    TablePermissions["MEDIA_SELECT"] = "media_select";
    TablePermissions["MEDIA_UPDATE"] = "media_update";
    TablePermissions["MEDIA_DELETE"] = "media_delete";
    TablePermissions["ASSET_MEDIA_INSERT"] = "asset_media_insert";
    TablePermissions["ASSET_MEDIA_SELECT"] = "asset_media_select";
    TablePermissions["ASSET_MEDIA_UPDATE"] = "asset_media_update";
    TablePermissions["ASSET_MEDIA_DELETE"] = "asset_media_delete";
    TablePermissions["USER_AVATAR_MEDIA_INSERT"] = "user_avatar_media_insert";
    TablePermissions["USER_AVATAR_MEDIA_SELECT"] = "user_avatar_media_select";
    TablePermissions["USER_AVATAR_MEDIA_UPDATE"] = "user_avatar_media_update";
    TablePermissions["USER_AVATAR_MEDIA_DELETE"] = "user_avatar_media_delete";
    TablePermissions["GLOBAL_AMENITY_INSERT"] = "global_amenity_insert";
    TablePermissions["GLOBAL_AMENITY_SELECT"] = "global_amenity_select";
    TablePermissions["GLOBAL_AMENITY_UPDATE"] = "global_amenity_update";
    TablePermissions["GLOBAL_AMENITY_DELETE"] = "global_amenity_delete";
    TablePermissions["ASSET_AMENITY_INSERT"] = "asset_amenity_insert";
    TablePermissions["ASSET_AMENITY_SELECT"] = "asset_amenity_select";
    TablePermissions["ASSET_AMENITY_UPDATE"] = "asset_amenity_update";
    TablePermissions["ASSET_AMENITY_DELETE"] = "asset_amenity_delete";
    TablePermissions["INVITE_INSERT"] = "invite_insert";
    TablePermissions["INVITE_SELECT"] = "invite_select";
    TablePermissions["INVITE_UPDATE"] = "invite_update";
    TablePermissions["INVITE_DELETE"] = "invite_delete";
    TablePermissions["USER_GROUP_ROLE_INSERT"] = "user_group_role_insert";
    TablePermissions["USER_GROUP_ROLE_SELECT"] = "user_group_role_select";
    TablePermissions["USER_GROUP_ROLE_UPDATE"] = "user_group_role_update";
    TablePermissions["USER_GROUP_ROLE_DELETE"] = "user_group_role_delete";
    TablePermissions["USER_GROUP_INTEGRATIONS_INSERT"] = "user_group_integrations_insert";
    TablePermissions["USER_GROUP_INTEGRATIONS_SELECT"] = "user_group_integrations_select";
    TablePermissions["USER_GROUP_INTEGRATIONS_UPDATE"] = "user_group_integrations_update";
    TablePermissions["USER_GROUP_INTEGRATIONS_DELETE"] = "user_group_integrations_delete";
    TablePermissions["USER_GROUP_INTEGRATIONS_DATA_INSERT"] = "user_group_integrations_data_insert";
    TablePermissions["USER_GROUP_INTEGRATIONS_DATA_SELECT"] = "user_group_integrations_data_select";
    TablePermissions["USER_GROUP_INTEGRATIONS_DATA_UPDATE"] = "user_group_integrations_data_update";
    TablePermissions["USER_GROUP_INTEGRATIONS_DATA_DELETE"] = "user_group_integrations_data_delete";
    TablePermissions["GROUP_USER_ROLE_INSERT"] = "group_user_role_insert";
    TablePermissions["GROUP_USER_ROLE_SELECT"] = "group_user_role_select";
    TablePermissions["GROUP_USER_ROLE_UPDATE"] = "group_user_role_update";
    TablePermissions["GROUP_USER_ROLE_DELETE"] = "group_user_role_delete";
    TablePermissions["OWNER_INSERT"] = "owner_insert";
    TablePermissions["OWNER_SELECT"] = "owner_select";
    TablePermissions["OWNER_UPDATE"] = "owner_update";
    TablePermissions["OWNER_DELETE"] = "owner_delete";
    TablePermissions["ACCOUNT_INSERT"] = "account_insert";
    TablePermissions["ACCOUNT_SELECT"] = "account_select";
    TablePermissions["ACCOUNT_UPDATE"] = "account_update";
    TablePermissions["ACCOUNT_DELETE"] = "account_delete";
    TablePermissions["USER_GROUP_USER_ACCOUNT_INSERT"] = "user_group_user_account_insert";
    TablePermissions["USER_GROUP_USER_ACCOUNT_SELECT"] = "user_group_user_account_select";
    TablePermissions["USER_GROUP_USER_ACCOUNT_UPDATE"] = "user_group_user_account_update";
    TablePermissions["USER_GROUP_USER_ACCOUNT_DELETE"] = "user_group_user_account_delete";
    TablePermissions["USER_GROUP_ACCOUNT_INSERT"] = "user_group_account_insert";
    TablePermissions["USER_GROUP_ACCOUNT_SELECT"] = "user_group_account_select";
    TablePermissions["USER_GROUP_ACCOUNT_UPDATE"] = "user_group_account_update";
    TablePermissions["USER_GROUP_ACCOUNT_DELETE"] = "user_group_account_delete";
    TablePermissions["DASHBOARD_VIEWER"] = "dashboard_viewer";
    TablePermissions["DASHBOARD_DOWNLOAD"] = "dashboard_download";
    TablePermissions["CAMPAIGN_INSERT"] = "campaign_insert";
    TablePermissions["CAMPAIGN_SELECT"] = "campaign_select";
    TablePermissions["CAMPAIGN_UPDATE"] = "campaign_update";
    TablePermissions["CAMPAIGN_DELETE"] = "campaign_delete";
    // OWNER SPECIFIC PERMISSIONS
    TablePermissions["INVITE_INSERT_OWNER"] = "invite_insert_owner";
    TablePermissions["GROUP_USER_ROLE_INSERT_OWNER"] = "group_user_role_insert_owner";
    TablePermissions["GROUP_USER_ROLE_UPDATE_OWNER"] = "group_user_role_update_owner";
    TablePermissions["GROUP_USER_ROLE_DELETE_OWNER"] = "group_user_role_delete_owner";
})(TablePermissions = exports.TablePermissions || (exports.TablePermissions = {}));
exports.default = TablePermissions;
//# sourceMappingURL=tablePermissions.js.map